import Happy from "./happy.jpg";
import Mad from "./mad.jpg";
import Sad from "./sad.jpg";
import Worried from "./worried.jpg";

export default { Happy, Mad, Sad, Worried };
